import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { LocaleDatetimeFormatPipe } from '../../../../shared/pipes/locale-datetime-format.pipe';
import { SlicePipe } from '@angular/common';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { ICardActionHistoryRecord } from '../../core/interfaces/ICardActionHistoryRecord';

@Component({
  selector: 'app-actions-history-table',
  standalone: true,
  imports: [
    LocaleDatetimeFormatPipe,
    SlicePipe,
    TranslatePipe
  ],
  templateUrl: './actions-history-table.component.html',
  styleUrl: './actions-history-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionsHistoryTableComponent extends BaseComponent {

  @Input({ required: true }) cardActionsHistory: ICardActionHistoryRecord[] = [];

  public actionHistorySliceEnd = 5;
}
